import { useQuery } from "@tanstack/react-query";
import { api } from "shared/api";

// TODO: Rewrite using useMutation
export const useGetPaymentMethods = (enabled = true) => {
  const {
    data: paymentMethods,
    isFetching: isPaymentMethodsFetching,
    error: paymentMethodsError,
    refetch: refetchPaymentMethods,
  } = useQuery({
    queryKey: ["getPaymentMethodsInProvider"],
    queryFn: async () => {
      const res = await api().gersGetPaymentMethods();
      return res?.data;
    },
    refetchOnWindowFocus: false,
    enabled,
  });

  return {
    paymentMethods,
    isPaymentMethodsFetching,
    paymentMethodsError,
    refetchPaymentMethods,
  };
};
